import {isEqual} from 'lodash';
import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {billingPlatformApi} from 'api';
import {BillingAddressStep, InformationModal, Wizard} from 'components';
import {PAYMENT_SOURCE_ADDED} from 'constants/images';
import {TRANSLATION_KEYS} from 'locale';
import {BillingAddress} from 'types';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.BILLING_ADDRESS.EDIT_BILLING_ADDRESS_MODAL;

type Props = {
    open: boolean;
    billingAddress?: BillingAddress;
    onClose: (success: boolean) => void;
}

export const EditBillingAddressModal: React.FC<Props> = ({open, billingAddress, onClose}) => {
    const {t} = useTranslation();
    const [wizardInstance, setWizardInstance] = useState(null);
    const [updatedBillingAddress, setUpdatedBillingAddress] = useState(billingAddress);

    const handleClose = useCallback(() => {
        const addressUpdatedSuccessfully = wizardInstance && wizardInstance.currentStep === wizardInstance.totalSteps;
        return onClose(addressUpdatedSuccessfully);
    }, [onClose, wizardInstance]);

    return (
        <InformationModal maxWidth='sm' fullWidth open={open} title={t(T_KEYS.TITLE)} onClose={handleClose}>
            <Wizard instance={setWizardInstance}>
                <BillingAddressStep
                    value={billingAddress}
                    wizardFooterProps={{
                        hasNext: true,
                        disabledNext: isEqual(billingAddress, updatedBillingAddress)
                    }}
                    updateCallback={billingPlatformApi.updateBillingAddress}
                    onChange={setUpdatedBillingAddress}
                />
                <div className='tw-text-center'>
                    <div className='tw-ts-h5-bold tw-mb-8'>{t(T_KEYS.DONE.TITLE)}</div>
                    {/* TODO: update image */}
                    <img src={PAYMENT_SOURCE_ADDED} alt={t(T_KEYS.DONE.TITLE)} />
                </div>
            </Wizard>
        </InformationModal>
    );
};